import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import GeoPoint from "@/models/Shared/GeoPoint";

export default class UpdateAddressDetailsRequest extends BaseUpdateRequest {
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo = true;
    workTypes: string[] = [];
}